import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Color } from '../../../constants/color.constants';
import { Icons } from '../../../constants/icons.constants';

@Component({
    selector: 'faq-item',
    template: `
        <div class="faq-item">
            <div class="faq-item-header" (click)="handleClick.emit()">
                <div class="faq-item-header-caret">
                    <lsq-icon
                        [type]="isOpen ? icons.ChevronDown : icons.ChevronRight"
                        [color]="color.Black"
                    >
                    </lsq-icon>
                </div>
                <span>{{ faqTitle }}</span>
            </div>
            <div class="faq-item-body" *ngIf="isOpen">
                <ng-content></ng-content>
            </div>
        </div>
    `,
    styleUrls: ['./faq-item.component.scss']
})
export class FaqItemComponent {
    @Input() public isOpen = false;
    @Input() public faqTitle: string;
    @Output() public handleClick = new EventEmitter<void>();

    public icons = Icons;
    public color = Color;
}
